// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"de3aa9d8","453":"71f3b793","538":"e66f2254"}[chunkId] + ".chunk.js";
};